module.exports = __webpack_public_path__ + "static/img/d8.38788e6f.png";